/**
 * Portal SPA entry point.
 *
 * Renders the React application into the #root element.
 * Wraps the app with providers in the correct order:
 *   1. React.StrictMode (development checks)
 *   2. QueryClientProvider (TanStack Query for server state)
 *   3. BrowserRouter (React Router for client-side navigation)
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import './index.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found in index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
